import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { defaultGridData } from '../../../module/component/TableBoxModule';
import { PATH_DELIMITER, SEMESTER_STUDENT_ENROLMENT_CHECK_PATH } from '../../../constant/Constant';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { request } from '../../ApiModule';
import { SET_GRID_DATA } from '../../component/TableBoxModule';

const TAB_NO = 'TAB2';

const ACTION_SEARCH =
    SEMESTER_STUDENT_ENROLMENT_CHECK_PATH + PATH_DELIMITER + TAB_NO + PATH_DELIMITER + 'ACTION_SEARCH';
const ACTION_EXCEL_DOWNLOAD =
    SEMESTER_STUDENT_ENROLMENT_CHECK_PATH + PATH_DELIMITER + TAB_NO + PATH_DELIMITER + 'ACTION_EXCEL_DOWNLOAD';
const HANDLE_GRID_DATA =
    SEMESTER_STUDENT_ENROLMENT_CHECK_PATH + PATH_DELIMITER + TAB_NO + PATH_DELIMITER + 'HANDLE_GRID_DATA';

export const actionSearch = createAction(ACTION_SEARCH);
export const actionExcelDownload = createAction(ACTION_EXCEL_DOWNLOAD);

export function* semesterStudentEnrolmentCheckViewTab2BodySagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
    yield takeEvery(ACTION_EXCEL_DOWNLOAD, actionExcelDownloadSaga);
}

function* actionSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/enrolment/semesters/${params.semesterId}/by-user-university`,
        params,
        callback,
    });

    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: result,
        });
    }
}

function* actionExcelDownloadSaga({ payload: { params } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/enrolment/semesters/${params.semesterId}/by-user-university-excel-export`,
        params,
        download: true,
        downloadDirect: true,
        downloadType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
}

const initialState = {
    gridData: defaultGridData,
};

const module = handleActions(
    {
        [HANDLE_GRID_DATA]: (state, { payload: gridData }) => ({ ...state, gridData }),
    },
    initialState,
);

export default module;
